import { useSelector, shallowEqual } from "react-redux";

import ProductSummary from "app/pages/.shared/ProductSummary/ProductSummary";

const mapStateToProps = state => ({
	booking: state.booking,
	ficheProduit: state.ficheProduit,
	status: state.status,
});

const ProductSummaryContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <ProductSummary {...props} {...stateProps} />;
};

export default ProductSummaryContainer;
